<template>
    <div v-if="displayField">
    <div class="row form-group clearfix" :class="errorClass">
      <div class="col-md-4 col-lg-4 col-xl-3">
        <label class="h6 text-md-right">
          <span v-html="label"></span><br>
          <small class="text-black-50">Category</small>
        </label>
      </div>
      <div class="col-md-12 col-lg-12 col-xl-12">
        <select v-model="FieldSelect" @change="onSelectOption($event)" class="form-control col-12">
          <option class="list-group-item" v-for="info in parentCategory" :value="info">
            {{ info }}
          </option>
        </select>
      </div>
    </div>
    <div class="row form-group clearfix" :class="errorClass">
      <div class="col-md-4 col-lg-4 col-xl-3">
        <label class="h6 text-md-right">
          <span v-html="label"></span><br>
          <small class="text-black-50">Sub Category</small>
        </label>
      </div>
      <div class="col-md-12 col-lg-12 col-xl-12">
        <select v-model="ChildFieldSelect" @change="onSelectOptionChildCategory($event)" class="form-control col-12">
          <option class="list-group-item" v-for="info in childCategory" :value="info">
            {{ info }}
          </option>
        </select>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  require('vue-select-image/dist/vue-select-image.css')
  export default {
    props: [
      'label',
      'labelSecondary',
      'isRequired',
      'displayField',
      'errorClass',
      'categoryNomination',
      'checkboxLabels'
    ],
    data () {
      return {
        behaviours:null,
        behavioursChild:null,
        parentCategory: [],
        childCategory: [],
        FieldSelect: '',
        ChildFieldSelect: ''
      }
    },
    created () {
      console.log('ThinkTank src components FieldSelectGroup created ')
      var self = this
      self.displayField = window.location.href.includes('innovation-ideas')
      if (window.location.href.includes('innovation-ideas')) {
          self.parentCategory[0] = 'Product'
          self.parentCategory[1] = 'Business process'
          self.parentCategory[2] = 'General'      
          self.FieldSelect = 'Product'

          self.childCategory[0] = 'DMS'
          self.childCategory[1] = 'DStv Stream'
          self.childCategory[2] = 'General Entertainment'      
          self.childCategory[3] = 'Namola'
          self.childCategory[4] = 'Showmax'
          self.childCategory[5] = 'SuperSport'
          self.ChildFieldSelect = 'DMS'
      }
      console.log('Field updated with content: inside component addedSelectContent ', self.label, self.FieldSelect, self.displayField)
      self.$emit('addedCheckBoxesContent', {label: self.label, content: self.FieldSelect, validated: true, displayField: self.displayField})
    },
    methods: {
      onSelectOption(elem) {
            console.log(' dataImages 80 ', elem.target.value)
            if (elem.target.value === 'Product') {
                this.childCategory = []
                this.childCategory[0] = 'DMS'
                this.childCategory[1] = 'DStv Stream'
                this.childCategory[2] = 'General Entertainment'      
                this.childCategory[3] = 'Namola'
                this.childCategory[4] = 'Showmax'
                this.childCategory[5] = 'SuperSport'
                this.ChildFieldSelect = 'DMS'
            }
            if (elem.target.value === 'Business process') {
                this.childCategory = []
                this.childCategory[0] = 'Finance'
                this.childCategory[1] = 'Human Capital'
                this.childCategory[2] = 'Marketing'      
                this.childCategory[3] = 'Technology'
                this.ChildFieldSelect = 'Finance'
            }
            if (elem.target.value === 'General') {
                this.childCategory = []
                this.childCategory[0] = 'Technology'
                this.childCategory[1] = 'Customer'
                this.childCategory[2] = 'Other'
                this.ChildFieldSelect = 'Technology'
            }
            var content = this.FieldSelect+':'+this.ChildFieldSelect
            console.log('Field updated with content: inside component addedSelectContent ', this.label, this.label, this.FieldSelect)
            this.$emit('addedCheckBoxesContent', {label: this.label, content: content, validated: true, displayField: self.displayField})    
        },
        onSelectOptionChildCategory() {
            var content = this.FieldSelect+':'+this.ChildFieldSelect
            console.log('Field updated with content: inside component addedSelectContent ', this.label, this.label, this.ChildFieldSelect)
            this.$emit('addedCheckBoxesContent', {label: this.label, content: content, validated: true, displayField: this.displayField})    
        }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/FieldSelectGroup.vue